import axios from 'axios';

export default {
  getJsonData: async (url: string): Promise<unknown> => {
    const result = await axios.get(url);
    return result.data;
  },
};
